import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
function Etape3({ formData, handleChange, setFormData, user, isReadOnly, page, renderError }) {

  const [commentaire, setCommentaire] = useState("");

  const addCommentaire = () => {
    if (!commentaire.trim()) {
      alert('Le commentaire ne peut pas être vide.');
      return;
    }
    const now = new Date();
    const dateHeure = now.toLocaleString("fr-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
    const newCommentaire = {
      commentaireUsers: commentaire,
      nom: user.displayName,
      userId: user.id,
      courriel: user.mail,
      dateHeure,
      id: uuidv4(),  // Unique ID for this comment
      ancien: false
    };

    // Add the new comment to the listeDesNotes array
    setFormData(prevData => ({
      ...prevData,
      listeDesNotes: [...prevData.listeDesNotes, newCommentaire]
    }));

    setCommentaire("");  // Clear the input field after adding
  };

  const deleteCommentaire = (id) => {
    // Remove the comment with the specified ID from the listeDesNotes array
    setFormData(prevData => ({
      ...prevData,
      listeDesNotes: prevData.listeDesNotes.filter(note => note.id !== id)
    }));
  };


  // Recalculer 'montantkilometrage' quand 'depenses' change
  useEffect(() => {
    const newMontantKilometrage = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Kilométrage")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);



    setFormData((prevFormData) => ({
      ...prevFormData,
      montantkilometrage: parseFloat(newMontantKilometrage.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);


  // Recalculer 'montantVisaConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantVisaConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantVisaConseil: parseFloat(newMontantVisaConseil.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantAutresDepenses' quand 'depenses' change
  useEffect(() => {
    const newMontantAutresDepenses = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Autre dépense")
      .reduce((total, row) => total + (Number(row.montant) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantAutresDepenses: parseFloat(newMontantAutresDepenses.toFixed(2)),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantRembourserConseil' quand 'depenses' change
  useEffect(() => {
    const newMontantRembourserConseil = formData.depenses
      .flatMap((depense) => depense.rows)
      .filter((row) => row.typeDepenses === "Visa du Conseil")
      .reduce((total, row) => total + (Number(row.montantRembourser) || 0), 0);

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantRembourserConseil: parseFloat(
        newMontantRembourserConseil.toFixed(2)
      ),
    }));
  }, [formData.depenses, setFormData]);

  // Recalculer 'montantNet' quand les autres montants changent
  useEffect(() => {
    const kilometrage = parseFloat(formData.montantkilometrage) || 0;
    const autresDepenses = parseFloat(formData.montantAutresDepenses) || 0;
    const rembourserConseil = parseFloat(formData.montantRembourserConseil) || 0;

    const newMontantNet = kilometrage + autresDepenses - rembourserConseil;

    setFormData((prevFormData) => ({
      ...prevFormData,
      montantNet: parseFloat(newMontantNet.toFixed(2)),
    }));
  }, [
    formData.montantkilometrage,
    formData.montantAutresDepenses,
    formData.montantRembourserConseil,
    setFormData,
  ]);

  return (
    <div className=" p-4 ">
      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="numeroFormulaire"
            className="block text-sm font-medium text-blue-900"
          >
            Numéro de formulaire:
          </label>
          <input
            type="text"
            id="numeroFormulaire"
            name="numeroFormulaire"
            value={formData.numeroFormulaire}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200" />

        </div>
      </div>

      <div className="w-full grid grid-cols-1 gap-4 mb-4 sm:grid-cols-2">
        <div className="w-[45%]"></div>
        <div className="w-1/2  sm:ml-auto">
          <label
            htmlFor="dateEntreeEnVigueur"
            className="block text-sm font-medium text-blue-900"
          >
            Date :
          </label>
          <input
            type="date"
            id="dateSoumission"
            name="dateSoumission"
            value={formData.dateSoumission?.split("T")[0] ?? ""}
            onChange={handleChange}
            required
            disabled
            className="mt-1 p-3 w-full sm:w-3/4 border border-gray-200 rounded-xl bg-gray-50 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200" />

        </div>
      </div>

      <div className="w-full flex justify-center mt-6 mb-20">
        <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-md shadow-md w-fit">
          <p className="text-md font-bold flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6 text-blue-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 17v-2a4 4 0 014-4h6m-6 0V9m0 0H9m3 0h3"
              />
            </svg>
            Réclamation mensuelle de dépenses d'emploi
          </p>
        </div>
      </div>

      <div className="w-full bg-gradient-to-r from-gray-800 to-gray-600 py-3 shadow-md rounded-t-2xl">
        <p className="text-lg font-semibold text-white ml-4 tracking-wide flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-pink-400 mr-2"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 17v-6h6v6m2 4H7a2 2 0 01-2-2V7a2 2 0 012-2h5l2 2h5a2 2 0 012 2v12a2 2 0 01-2 2z"
            />
          </svg>
          Sommaire des dépenses réclamées
        </p>
      </div>

      <div className="mt-8 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="montantkilometrage"
            className="block text-sm font-medium text-blue-900"
          >
            Montant du kilométrage :
          </label>
          <div className="relative">
            <input
              type="text"
              // step="0.01"
              id="montantkilometrage"
              name="montantkilometrage"
              value={
                formData.montantkilometrage !== null &&
                  formData.montantkilometrage !== undefined
                  ? parseFloat(formData.montantkilometrage).toFixed(2)
                  : ""
              }
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
          </div>

        </div>

        <div className="w-3/5">
          <label
            htmlFor="montantVisaConseil"
            className="block text-sm font-medium text-blue-900"
          >
            Montant des dépenses Visa du Conseil :
          </label>
          <div className="relative">
            <input
              type="text"
              // step="0.01"
              id="montantVisaConseil"
              name="montantVisaConseil"
              value={
                formData.montantVisaConseil !== null &&
                  formData.montantVisaConseil !== undefined
                  ? parseFloat(formData.montantVisaConseil).toFixed(2)
                  : ""
              }
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
          </div>

        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="montantAutresDepenses"
            className="block text-sm font-medium text-blue-900"
          >
            Montant des autres dépenses :
          </label>
          <div className="relative">
            <input
              type="text"
              // step="0.01"
              id="montantAutresDepenses"
              name="montantAutresDepenses"
              value={
                formData.montantAutresDepenses !== null &&
                  formData.montantAutresDepenses !== undefined
                  ? parseFloat(formData.montantAutresDepenses).toFixed(2)
                  : ""
              }
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
          </div>
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="montantRembourserConseil"
            className="block text-sm font-medium text-blue-900"
          >
            Montant à rembourser au Conseil :
          </label>
          <div className="relative">
            <input
              type="text"
              // step="0.01"
              id="montantRembourserConseil"
              name="montantRembourserConseil"
              value={
                formData.montantRembourserConseil !== null &&
                  formData.montantRembourserConseil !== undefined
                  ? parseFloat(formData.montantRembourserConseil).toFixed(2)
                  : ""
              }
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
          </div>
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5">
          <label
            htmlFor="montantNet"
            className="block text-sm font-medium text-blue-900"
          >
            Montant net :
          </label>
          <div className="relative">
            <input
              type="text"
              // step="0.01"
              id="montantNet"
              name="montantNet"
              value={
                formData.montantNet !== null &&
                  formData.montantNet !== undefined
                  ? parseFloat(formData.montantNet).toFixed(2)
                  : ""
              }
              readOnly
              className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            />
            <span className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-600 pointer-events-none">$</span>
          </div>
        </div>
      </div>

      <div className="mt-10 w-3/4 grid grid-cols-2 gap-0">
        <div className="w-3/5 mt-4">
          <label
            htmlFor="commentaire"
            className="block text-sm font-medium text-blue-900"
          >
            Commentaires :
          </label>

          <textarea
            placeholder="Ajoutez un commentaire..."
            className="mt-1 w-full p-3 border border-gray-200 rounded-xl  shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 focus:border-purple-400 transition-all duration-200"
            rows="5"
            id="commentaire"
            name="commentaire"
            value={commentaire}
            onChange={(e) => setCommentaire(e.target.value)}  // Fixing the onChange handler
            readOnly={isReadOnly && page !== "Mes taches"}
          />
          {renderError("commentaireTable")}
        </div>

      </div>
      {(isReadOnly === false || (page === "Mes taches" && formData.etatDemande !== "Rejeté")) && (
        <button
          type="button"
          className="mt-5 bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={addCommentaire}
        >
          + Ajouter un commentaire
        </button>)}

      {/* Table to display the list of users with comments */}
      <div className="mt-8 w-3/4">
        <h3 className="font-bold text-lg mb-4 text-gray-800">Liste des utilisateurs avec commentaires :</h3>

        <div className="overflow-x-auto rounded-xl shadow-md border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200 bg-white">
            <thead className="bg-blue-600">
              <tr>
                <th className="p-3 text-left text-white text-sm font-medium w-1/5">Nom</th>
                <th className="p-3 text-left text-white text-sm font-medium w-1/4">Courriel</th>
                <th className="p-3 text-left text-white text-sm font-medium w-1/5">Commentaire</th>
                <th className="p-3 text-left text-white text-sm font-medium w-1/5" >Date et heure</th>
                <th className="p-3 text-left text-white text-sm font-medium ">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {formData.listeDesNotes.map((note) => (
                <tr
                  key={note.id}
                  className="hover:bg-gray-50 transition-colors duration-150"
                >
                  <td className="p-3 text-gray-700 whitespace-normal break-words break-all max-w-xs">{note.nom}</td>
                  <td className="p-3 text-gray-700 whitespace-normal break-words break-all max-w-xs">{note.courriel}</td>
                  <td className="p-3 text-gray-700 whitespace-normal break-words break-all max-w-xs">{note.commentaireUsers}</td>
                  <td className="p-3 text-gray-700 whitespace-normal break-words break-all max-w-xs">{note.dateHeure}</td>
                  <td className="p-3">
                    {!note.ancien && (
                      <button
                        type="button"
                        className="text-red-600 hover:text-red-800 font-semibold"
                        onClick={() => deleteCommentaire(note.id)}
                      >
                        Supprimer
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
}

export default Etape3;
